import { Guid } from "@/Common/Models/Guid";

// port of the Myle.Entities.Patient buisness object model
class Patient {
    public ContactFacet_id: Guid;
    public Employer: string;
    public Profession: string;
    public ChartNumber: string;
    public Notes: string;
    public PatientStatusDate: string;
    public PatientStatusLookupId: string;
    public SocialNumber: string;
    public Identifier01: string;
    public Identifier02: string;
    public Identifier03: string;
    public DirectoryPharmacyId?: string;
    public IsTest: boolean;
}

export { Patient };
